import { Flex, IconButton, Text, VStack } from "@chakra-ui/react";
import { SelectControl } from "formik-chakra-ui";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Card } from "src/components/Layout/Card";
import { type EligibilityDataPoint } from "src/generated/hooks/form-service/requests";
import * as RD from "src/types/remoteData";
import { BoundarySelect } from "./BoundarySelect";
import { DataPointSelect } from "./DataPointSelect";

export function AddressConditionCard({
  name,
  enrollmentPeriodId,
  dataPoints,
  onDelete,
}: {
  name: string;
  enrollmentPeriodId: string;
  dataPoints: RD.RemoteData<Error, EligibilityDataPoint[]>;
  onDelete: () => void;
}) {
  return (
    <Card showBorder>
      <VStack align="stretch" spacing={4}>
        <Flex align="center" justify="space-between" gap={3}>
          <Text fontSize="md" fontWeight="medium" color="blackAlpha.800">
            Address condition
          </Text>
          <IconButton
            aria-label="Delete address condition"
            icon={<RiDeleteBin6Line />}
            variant="outline"
            colorScheme="gray"
            size="sm"
            onClick={onDelete}
          />
        </Flex>

        <DataPointSelect
          name={`${name}.dataPointId`}
          enrollmentPeriodId={enrollmentPeriodId}
          dataPoints={dataPoints}
          dataPointType="Address"
        />

        <SelectControl
          name={`${name}.operator`}
          label="Is"
          selectProps={{ placeholder: "Select" }}
        >
          <option value="within">Inside boundary</option>
          <option value="notWithin">Outside boundary</option>
        </SelectControl>

        <BoundarySelect name={`${name}.boundaryId`} />
      </VStack>
    </Card>
  );
}
